export default __webpack_public_path__ + "static/media/R5C_8223.41281475.jpg";